import { render } from "./AposCloudUploadIcon.vue?vue&type=template&id=5822fac1&scoped=true"
const script = {}

import "./AposCloudUploadIcon.vue?vue&type=style&index=0&id=5822fac1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5822fac1"],['__file',"ui/ui/apos/components/AposCloudUploadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5822fac1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5822fac1', __exports__)) {
    api.reload('5822fac1', __exports__)
  }
  
  module.hot.accept("./AposCloudUploadIcon.vue?vue&type=template&id=5822fac1&scoped=true", () => {
    api.rerender('5822fac1', render)
  })

}


export default __exports__